import { useSelector } from 'react-redux';
import styles from './SaveButton.module.css';
import { addDocBd } from '../../firebase';
import { useState } from 'react';
import LoaderPage from '../LoaderPage/LoaderPage';

const SaveButton = ({
  collection,
  documentId,
  data,
  merge = true,
  onSuccess,
  onError,
  textBtn = 'Зберегти',
}) => {
  const settingsApplication = useSelector((state) => state.settingsApplication.settingsApplication);
  const [loaderPage, setLoaderPage] = useState(false);

  // Зберігає на сервер
  const handleClick = async () => {
    const isSave = window.confirm('Зберегти налаштування?');
    if (isSave) {
      setLoaderPage(true);
      const isAddDoc = await addDocBd(
        'settingsApplication',
        settingsApplication.id,
        settingsApplication,
      );
      if (!isAddDoc) {
        alert('Не вдалося зберегти данні!!!');
      }
      setLoaderPage(false);
    }
  };

  return (
    <>
      <button className={styles.button} onClick={handleClick}>
        {textBtn}
      </button>
      {loaderPage && <LoaderPage />}
    </>
  );
};

export default SaveButton;
